__turbopack_context__.v({
  "asset": "course-preview-entry-point-module-scss-module___Jq7va__asset",
  "collapsed": "course-preview-entry-point-module-scss-module___Jq7va__collapsed",
  "desktop-placeholder": "course-preview-entry-point-module-scss-module___Jq7va__desktop-placeholder",
  "fade-out": "course-preview-entry-point-module-scss-module___Jq7va__fade-out",
  "gradient": "course-preview-entry-point-module-scss-module___Jq7va__gradient",
  "img-aspect": "course-preview-entry-point-module-scss-module___Jq7va__img-aspect",
  "mobile-preview": "course-preview-entry-point-module-scss-module___Jq7va__mobile-preview",
  "overlay": "course-preview-entry-point-module-scss-module___Jq7va__overlay",
  "placeholder": "course-preview-entry-point-module-scss-module___Jq7va__placeholder",
  "placeholder-btn": "course-preview-entry-point-module-scss-module___Jq7va__placeholder-btn",
  "placeholder-img": "course-preview-entry-point-module-scss-module___Jq7va__placeholder-img",
  "preview-btn": "course-preview-entry-point-module-scss-module___Jq7va__preview-btn",
  "text": "course-preview-entry-point-module-scss-module___Jq7va__text",
  "transition-container": "course-preview-entry-point-module-scss-module___Jq7va__transition-container",
  "wrapper": "course-preview-entry-point-module-scss-module___Jq7va__wrapper",
});
